import axios from "axios";

const lms_v2_api = axios.create({
    baseURL: process.env.REACT_APP_LMS_V2_API || "https://api-v2.dev99lms.com",
    //local
    // baseURL: "http://127.0.0.1:7000",
    headers: {
      "Content-Type": "application/json",
    },
  });
const lms_login_service_api = axios.create({
    baseURL: process.env.REACT_APP_LMS_LOGIN_API || "https://identity-service.dev99lms.com",
    //local
    // baseURL: "http://127.0.0.1:5000",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const global_var = {
    lmsClientUrl: process.env.REACT_APP_LMS_CLIENT_URL || "https://*.dev99lms.com/"
  }

  const google_redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI || "https://cs.login.cybersquare.org/google_sign"
  

  export { lms_v2_api, global_var,lms_login_service_api,google_redirectUri };
  